module.exports = __webpack_public_path__ + "static/media/appstore.da392a4d.svg";